
export enum ScaleitConfirmDialogResult {
    Close,
    No,
    Yes
  }
